import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subject, catchError, debounceTime, distinctUntilChanged, finalize, switchMap, takeUntil, tap, of } from 'rxjs'
import { ContractorRead, ContractorsService, OrderRead, OrdersService } from '@app/generated'
import { FormControl, Validators } from '@angular/forms'
import { ModalService } from '@core/services/modal.service'
import { LoaderService } from '@core/services/loader.service'
import { NotificationService } from '@core/services/notification.service'

@Component({
	selector: 'app-entity-change',
	templateUrl: './entity-change.component.html',
	styleUrl: './entity-change.component.scss',
})
export class EntityChangeComponent implements OnInit, OnDestroy {
	orderId!: string
	entityId!: string
	orderNumber!: string

	searchValue: string = ''
	isLoading: boolean = false
	control = new FormControl<string | null>(null, Validators.required)
	options: ContractorRead[] = []

	readonly noResultsText: string = $localize`No results`
	readonly pleaseWaitText: string = $localize`Please wait...`
	readonly selectContractor: string = $localize`Select a contractor`
	readonly textSubmit: string = $localize`Submit`
	private readonly search$: Subject<string> = new Subject<string>()
	private readonly destroy$: Subject<void> = new Subject<void>()

	constructor(
		private contractorsService: ContractorsService,
		private ordersService: OrdersService,
		private modalService: ModalService,
		private loaderService: LoaderService,
		private notificationService: NotificationService,
	) {}

	ngOnInit(): void {
		this.search$
			.pipe(
				debounceTime(250),
				distinctUntilChanged(),
				tap(() => {
					this.isLoading = true
				}),
				switchMap(value =>
					this.contractorsService.getEntities(0, 10, encodeURIComponent(value)).pipe(
						catchError(() => {
							this.options = []
							this.notificationService.error($localize`Error during fetching contractors`)
							return of({ items: [] } as unknown as { items: ContractorRead[] })
						}),
					),
				),
				finalize(() => {
					this.isLoading = false
				}),
				takeUntil(this.destroy$),
			)
			.subscribe(response => {
				this.options = response.items
			})
	}

	handleSearchValueChanges(value: string): void {
		this.search$.next(value)
	}

	ngOnDestroy(): void {
		this.destroy$.next()
		this.destroy$.complete()
		this.search$.complete()
	}

	handleSubmit(): void {
		if (!this.control.valid) {
			this.notificationService.error($localize`You need to choose contractor!`)
			return
		}
		this.loaderService.setContain()
		this.loaderService.setLoadingState(true)
		this.ordersService
			.patchOrder(this.orderId, {
				entity_id: this.control.value,
			})
			.pipe(finalize(() => this.loaderService.disable()))
			.subscribe({
				next: (response: OrderRead) => {
					this.modalService.modalRef.close(response)
				},
				error: () => {
					this.notificationService.error($localize`Failed to update entity`)
				},
			})
	}
}
